// extracted by mini-css-extract-plugin
export var section = "RequestDemo-module--section--lqrh1";
export var container = "RequestDemo-module--container---Nrbe";
export var column = "RequestDemo-module--column--4qFr6";
export var description = "RequestDemo-module--description--W6r9t";
export var text = "RequestDemo-module--text--gqdtY";
export var btns = "RequestDemo-module--btns--YXjOW";
export var image_bg = "RequestDemo-module--image_bg--JCsKj";
export var overlay = "RequestDemo-module--overlay--7GCcj";
export var image = "RequestDemo-module--image--rtVis";